var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverlapLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4653",
    "data-name": "Rectangle 4653",
    width: 25,
    height: 25,
    transform: "translate(282 135)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4561",
    "data-name": "Rectangle 4561",
    width: 25,
    height: 25,
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path831",
    d: "M0-25H25V0H0Z",
    fill: "#cecdcd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_164",
    "data-name": "Mask Group 164",
    transform: "translate(-282 -135)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_161",
    "data-name": "Mask Group 161",
    transform: "translate(282 135)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "translate-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g825",
    transform: "translate(0 25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g829",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g839",
    transform: "translate(13.307 -13.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path841",
    d: "M0,0H-9.413a1.967,1.967,0,0,0-1.962,1.962V7.453l-2.747,1.96,2.745,1.962a1.967,1.967,0,0,0,1.963,1.958H0a1.967,1.967,0,0,0,1.962-1.958V1.962A1.967,1.967,0,0,0,0,0Z",
    transform: "translate(9 -1)",
    fill: "rgba(0,0,0,0)",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.465
  })), /*#__PURE__*/React.createElement("g", {
    id: "g843",
    transform: "translate(10.932 -10.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path845",
    d: "M0,0H-8.237A1.967,1.967,0,0,1-10.2-1.962v-9.413a1.967,1.967,0,0,1,1.962-1.958H1.177a1.967,1.967,0,0,1,1.962,1.958L5.883-9.413,3.138-7.453v4.315",
    fill: "rgba(0,0,0,0)",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.465
  })), /*#__PURE__*/React.createElement("g", {
    id: "g847",
    transform: "translate(8.25 -18.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "M0,0A3.118,3.118,0,0,1-.848,1.755,3.118,3.118,0,0,1-1.7,0ZM1.4,2.713A3.107,3.107,0,0,1-.2,2.272,3.94,3.94,0,0,0,.833,0H1.4a.413.413,0,0,0,.413-.413A.413.413,0,0,0,1.7-.71.413.413,0,0,0,1.4-.833H-.432v-1a.413.413,0,0,0-.413-.413.413.413,0,0,0-.294.12.413.413,0,0,0-.122.293v1H-3.1a.413.413,0,0,0-.413.413.413.413,0,0,0,.118.3A.413.413,0,0,0-3.1,0h.57A3.94,3.94,0,0,0-1.5,2.272a3.108,3.108,0,0,1-1.6.443.413.413,0,0,0-.413.413.413.413,0,0,0,.413.413A3.93,3.93,0,0,0-.848,2.833a3.93,3.93,0,0,0,2.25.705.417.417,0,0,0,0-.833",
    fill: "#555"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g835",
    transform: "translate(18.278 -6.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path837",
    d: "M0,0-.683-2.408-1.365,0ZM-2.863,1.623a.455.455,0,0,1,.015-.078l1.515-4.933a.637.637,0,0,1,.65-.347.661.661,0,0,1,.667.345L1.49,1.545a.347.347,0,0,1,.01.078c0,.243-.368.423-.643.423-.167,0-.307-.055-.345-.2L.22.8h-1.8l-.3,1.043c-.04.148-.167.2-.345.2-.275,0-.643-.167-.643-.423",
    fill: "#555"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlapLight);
export default __webpack_public_path__ + "static/media/overlapLight.8f0294dfd1960ab26e858d61fb0f2304.svg";
export { ForwardRef as ReactComponent };